import { Component, Input, Output, EventEmitter, ViewChild, DoCheck } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DataBagService } from 'src/app/common/data-bag.service';
import { Router } from '@angular/router';
export interface PeriodicElement {
	id: number;
}

@Component({
	selector: 'app-location-optional-trip-list',
	templateUrl: './location-optional-trip-list.component.html',
	styleUrls: ['./location-optional-trip-list.component.css'],
})
export class LocationOptionalTripListComponent implements DoCheck {
	@Input() data: any;
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	optionalTrip: Array<any> = [];

	displayedColumns: string[] = ['name', 'description', 'isActive', 'edit'];

	constructor(
		private readonly bag: DataBagService,
		private readonly router: Router,
	) {}

	ngDoCheck() {
		const reg = /<[^>]*>/g;
		if (this.data.locationOptionalTrips != undefined) {
			this.data.locationOptionalTrips.map((item) => {
				if (item.optionalTrip.description != undefined) {
					item.optionalTrip.description = item.optionalTrip.description.replace(reg, ' ');
				}

				return item;
			});
		}
	}

	protected editOptionalTrip(el) {
		this.router.navigate(['/optionalTrip/' + el.optionalTrip.id]);
	}

	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.data.locationOptionalTrips, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}
}
